var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProxy = function SvgProxy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.132 30.988h-7.404L25.132 42.584v7.404l11.596 11.596h7.404l11.596-11.596v-7.404L44.132 30.988ZM55.144 46h23.562M11.644 46h13.062",
    stroke: "currentColor",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.43,
    cy: 46.286,
    r: 5.953,
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m72.18 36.06 7.536 8.535v2.81l-7.535 8.536",
    stroke: "currentColor",
    strokeWidth: 3
  })));
};
export default SvgProxy;